import React from 'react';
import useScrollReveal from '../../hooks/useScrollReveal';

/**
 * Wraps children in a fade-in-on-scroll element.
 * @param {string} as       element tag (default 'div')
 * @param {number} delay    stagger index 1–5 -> reveal-delay-N
 */
export default function Reveal({
  as: Tag = 'div',
  delay,
  className = '',
  children,
  ...rest
}) {
  const [ref, visible] = useScrollReveal();
  const delayClass = delay ? `reveal-delay-${delay}` : '';
  return (
    <Tag
      ref={ref}
      className={`reveal ${delayClass} ${visible ? 'is-visible' : ''} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
